const UUID_PATTERN =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

export function isPersistedUuid(id) {
  return typeof id === 'string' && UUID_PATTERN.test(id);
}

export function buildTextFieldStackKey(resourceType, resourceId, fieldName) {
  return `${resourceType}:${resourceId}:${fieldName}`;
}
